import { h, Component } from 'preact';
import Phone from 'components/bolt/icons/phone';
import s from 'components/bolt/landscapeOverlay/landscapeOverlay.sss';

export default class LandscapeOverlay extends Component {

	render() {
		return (
			<div className={s.wrapper}>
				<Phone class={s.phoneIcon} ariaLabel="Phone Icon" />
			</div>
		);
	}
}
